$(document).ready(function () {
    if ($('[data-button-colour]').length) {
        $('[data-button-colour]').each(function () {
            $(this).css("background-color", $(this).data("button-colour"));
        });
    }

    if ($('[data-button-border]').length) {
        $('[data-button-border]').each(function () {
            $(this).css("border-color", $(this).data("button-border"));
        });
    }

    if ($('[data-button-text]').length) {
        $('[data-button-text]').each(function () {
            $(this).css("color", $(this).data("button-text"));
        });
    }

    if ($('[data-background-image]').length) {
        $('[data-background-image]').each(function () {
            $(this).css("background-image", "url(" + $(this).data("background-image") + ")");
        });
    }

    if ($('[data-gradient-image]').length && $('[data-gradient-top]').length && $('[data-gradient-bottom]').length) {
        $('[data-gradient-image]').each(function () {
            $(this).css("background", "linear-gradient(180deg, " + $(this).data("gradient-top") + " 45%," + $(this).data("gradient-bottom") + " 100%), url(" + $(this).data("gradient-image") + ") lightgray 50% / cover no-repeat");
        });
    }

    if ($('[data-gradient-background]').length) {
        $('[data-gradient-background]').each(function () {
            if ($(this).data("gradient-background") === "Horizontal" && $('[data-gradient-left]').length && $('[data-gradient-right]').length) {
                $(this).css("background", "linear-gradient(279deg, " + $(this).data("gradient-right") + " 20%," + $(this).data("gradient-left") + " 100%)");
            }
            else if ($(this).data("gradient-background") === "Vertical" && $('[data-gradient-top]').length && $('[data-gradient-bottom]').length) {
                $(this).css("background", "linear-gradient(180deg, " + $(this).data("gradient-top") + " 20%," + $(this).data("gradient-bottom") + " 100%)");
            }
        });
    }

    if ($('[data-animation-duration]').length) {
        $('[data-animation-duration]').each(function () {
            $(this).css("animation-duration", $(this).data("animation-duration") + "s");
        });
    }

    $('#layout_mode').on('change', function () {
        if ($(this).prop('checked')) {
            window.location.href = window.location.pathname + '?layout=1&category=' + $(this).attr('category') + '&search=' + $(this).attr('search') + '&page=' + $(this).attr('page');
        }
        else {
            window.location.href = window.location.pathname + '?layout=0&category=' + $(this).attr('category') + '&search=' + $(this).attr('search') + '&page=' + $(this).attr('page');
        }
    });

    if ($('.btn-submit').length) {
        $('.btn-submit').on('click', function () {
            var form = $(this).closest('form');
            form.submit();
        });
    }

    if ($('.submit-enter').length) {

        $('.submit-enter').on('keydown', function (event) {
            var form = $(this).closest('form');

            if (event.keyCode === 13) {
                event.preventDefault();
                form.submit();
            }
        });
    }

    if ($('.tab-indicators').length) {
        $('[data-ts-target]').on('click', function () {
            var indicators = $(this).closest('.tab-indicators').children('[data-ts-target]');
            indicators.each(function () {
                $(this).removeClass('active')
            })
            $(this).addClass('active')

            var tabInner = $($(this).data('ts-target')).children('.tab-inner').first()
            var itemWidth = tabInner.children('.tab-item').first().innerWidth();
            var target = $(this).data('ts-slide-to');
            tabInner.css('transform', 'translateX(-' + itemWidth * target + 'px)');
        });
    }

    if ($('[autoSubmit]').length) {
        $('[autoSubmit]').on('change', function () {
            var form = $(this).closest('form');
            form.submit();
        });
    }

    if ($('.swiper[data-slides-desktop]').length) {

        function clamp(n, min, max) {
            return Math.max(min, Math.min(max, n));
        }

        $('.swiper[data-slides-desktop]').each(function () {

            const swiperEl = this;

            // Destroy if already initialised
            if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

            // Read config from data-attrs
            const total = parseInt(swiperEl.dataset.slidesTotal || '0', 10) || swiperEl.querySelectorAll('.swiper-slide').length;

            const mobile = clamp(parseInt(swiperEl.dataset.slidesMobile || '1', 10) || 1, 1, Math.max(1, total));
            const tablet = clamp(parseInt(swiperEl.dataset.slidesTablet || '1', 10) || 1, 1, Math.max(1, total));
            const desktop = clamp(parseInt(swiperEl.dataset.slidesDesktop || '1', 10) || 1, 1, Math.max(1, total));

            const style = (swiperEl.dataset.swiperStyle || '').toLowerCase();

            const spaceSmall = (style === "testimonials" ? 40 : 10);
            const spaceLarge = (style === "testimonials" ? 60 : 24);

            // Find nav scoped to THIS swiper-container
            const container = swiperEl.closest('.swiper-container');
            const prevEl = container ? container.querySelector('.swiper-button-prev') : null;
            const nextEl = container ? container.querySelector('.swiper-button-next') : null;

            const hasNav = !!(prevEl && nextEl);

            // Prefer stability first: no loop, use rewind
            const swiper = new Swiper(swiperEl, {
                direction: 'horizontal',
                grabCursor: true,

                loop: false,
                rewind: true,

                slidesPerView: mobile,
                slidesPerGroup: 1,
                centeredSlides: false,
                spaceBetween: 0,

                watchOverflow: true,

                // Helpful if component is inside layout that changes
                observer: true,
                observeParents: true,

                mousewheel: { forceToAxis: true },
                speed: 700,
                slideActiveClass: 'is-active',

                navigation: hasNav ? { prevEl, nextEl } : undefined,

                breakpoints: {
                    0: { slidesPerView: mobile, spaceBetween: 0 },
                    950: { slidesPerView: tablet, spaceBetween: spaceSmall },
                    1250: { slidesPerView: desktop, spaceBetween: spaceLarge }
                },

                on: {
                    init(s) {
                        if (hasNav && s.navigation) {
                            s.navigation.init();
                            s.navigation.update();
                        }
                        updateArrows(s);
                    },
                    breakpoint(s) {
                        if (hasNav && s.navigation) s.navigation.update();
                        updateArrows(s);
                    },
                    resize(s) {
                        if (hasNav && s.navigation) s.navigation.update();
                        updateArrows(s);
                    }
                }
            });

            function currentSlidesPerView(s) {
                // in our config it is always numeric at runtime
                const v = s.params.slidesPerView;
                return (typeof v === 'number' && isFinite(v)) ? v : 1;
            }

            function updateArrows(s) {
                if (!hasNav) return;
                const spv = currentSlidesPerView(s);
                const fits = total <= spv;
                prevEl.style.display = fits ? 'none' : '';
                nextEl.style.display = fits ? 'none' : '';
            }

            // One extra update after paint
            setTimeout(() => {
                swiper.update();
                if (hasNav && swiper.navigation) swiper.navigation.update();
            }, 0);

            // Debug (remove later)
            console.debug('[swiper]', {
                style, total,
                mobile, tablet, desktop,
                width: window.innerWidth,
                hasNav
            });
        });
    }


    /*

    if ($('.swiper[swiper-view]').length) {

        $('.swiper[swiper-view]').each(function () {

            // If Swiper already initialised this element, destroy it first
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }

            var $el = $(this);

            var noOfPanels = parseInt($el.attr('swiper-no'), 10) || $el.find('.swiper-slide').length;
            var noInView = parseInt($el.attr('swiper-view'), 10) || 1;
            var style = $el.attr('swiper-style');

            // Clamp CMS value so it never exceeds available slides
            var desktopView = Math.max(1, Math.min(noInView, noOfPanels));

            // Don’t loop if everything fits (prevents duplicate/odd behaviour with few slides)
            var noScroll = (noOfPanels <= desktopView);

            var spaceSmall = (style == "testimonials" ? 40 : 10);
            var spaceLarge = (style == "testimonials" ? 60 : 24);

            new Swiper(this, {
                direction: 'horizontal',
                grabCursor: true,

                // Base (small screens): always 1 slide
                slidesPerView: 1,
                slidesPerGroup: 1,
                centeredSlides: false,
                spaceBetween: 0,

                loop: !noScroll,
                loopAdditionalSlides: (noScroll ? 0 : 1),
                initialSlide: (noScroll ? 0 : 1),

                mousewheel: { forceToAxis: true },

                speed: 700,
                slideActiveClass: 'is-active',
                slideDuplicateActiveClass: 'is-active',

                // Breakpoints are MIN-widths in Swiper
                breakpoints: {
                    // Under 500px: force true full-width, no “peek”
                    0: {
                        slidesPerView: 1,
                        centeredSlides: false,
                        spaceBetween: 0,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    },

                    // 500–991: still 1 slide, slight gap if desired
                    500: {
                        slidesPerView: 1,
                        centeredSlides: false,
                        spaceBetween: 12,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    },

                    // 992+: show up to 2
                    992: {
                        slidesPerView: Math.min(2, desktopView),
                        centeredSlides: false,
                        spaceBetween: spaceLarge
                    },

                    // 1699+: use CMS value (clamped)
                    1699: {
                        slidesPerView: desktopView,
                        centeredSlides: false,
                        spaceBetween: spaceLarge
                    }
                }
            });

            // Debug (optional): confirms what Swiper thinks is active
            // console.log('Swiper init:', { width: window.innerWidth, noOfPanels, noInView, desktopView });
        });
    }
    */


    /*
    if ($('.swiper').length) {
        var swiperElement = $('[swiper-view]');
        var noOfPanels = swiperElement.attr('swiper-no');
        var noInView = swiperElement.attr('swiper-view');
        var style = swiperElement.attr('swiper-style');
        var noScroll = (parseInt(noOfPanels) <= 2 ? true : false)
        const swiper = new Swiper('.swiper', {
            direction: 'horizontal',
            grabCursor: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: false,
            loop: true,
            loopAdditionalSlides: (noScroll?0:1),
            initialSlide: (noScroll?0:1),
            spaceBetween: (style == "testimonials" ? 40: 10),
            mousewheel: {
                forceToAxis: true
            },
            breakpoints: {
                767: {
                    slidesPerView: (parseInt(noInView) <= 3 || noScroll ? 2 : Math.floor(parseInt(noInView) / 2)),
                    spaceBetween: (style == "testimonials" ? 60 : 24),
                }, 
                1699: {
                    slidesPerView: parseInt(noInView),
                    spaceBetween: (style == "testimonials" ? 60 : 24),
                },
            },
            speed: 700,
            slideActiveClass: 'is-active',
            slideDuplicateActiveClass: 'is-active'
        });
    }

    */
    /*
    if ($('.item-dropdown').length) {
        $('.item-dropdown').on('mouseenter', function () {
            var current = $(this);

            $('.item-dropdown').each(function () {
                if (current != $(this)) {
                    var collapseItem = $(this).attr('dropdown-collapse');
                    $(collapseItem).collapse('hide');
                    $(this).find('span').css({ 'transform': 'rotate(0deg)' });
                }
            });

            if ($('.collapsing').length == 0) {
                var collapseItem = current.attr('dropdown-collapse');
                $(collapseItem).collapse('show');
                current.find('span').css({ 'transform': 'rotate(180deg)' });
            }
        });

        $('.item-dropdown').on('mouseleave', function () {
            var current = $(this);
            var collapseItem = current.attr('dropdown-collapse');
            $(collapseItem).collapse('hide');
            current.find('span').css({ 'transform': 'rotate(0deg)' });
        });
    }
    */
   /*
    if ($('.item-dropdown').length) {
        let closeTimer = null;

        function showCurrent($current) {
            const collapseSel = $current.attr('dropdown-collapse');
            const $panel = $(collapseSel);

            // hide all other open panels first
            $('.item-dropdown').not($current).each(function () {
                const otherSel = $(this).attr('dropdown-collapse');
                $(otherSel).collapse('hide');
                $(this).find('span').css({ 'transform': 'rotate(0deg)' });
            });

            // if something is mid-transition, wait until it's finished hiding, then show this one
            const $anyCollapsing = $('.dropdown-section.collapsing');
            if ($anyCollapsing.length) {
                $anyCollapsing.one('hidden.bs.collapse', function () {
                    $panel.collapse('show');
                    $current.find('span').css({ 'transform': 'rotate(180deg)' });
                });
                return;
            }

            $panel.collapse('show');
            $current.find('span').css({ 'transform': 'rotate(180deg)' });
        }

        function hideCurrent($current) {
            const collapseSel = $current.attr('dropdown-collapse');
            $(collapseSel).collapse('hide');
            $current.find('span').css({ 'transform': 'rotate(0deg)' });
        }

        $('.item-dropdown').on('mouseenter', function () {
            clearTimeout(closeTimer);
            showCurrent($(this));
        });

        // Delay close slightly so moving from the link into the submenu doesn't close it
        $('.item-dropdown').on('mouseleave', function () {
            const $current = $(this);
            clearTimeout(closeTimer);
            closeTimer = setTimeout(() => hideCurrent($current), 150);
        });

        // Keep it open when hovering the dropdown panel itself
        $('.dropdown-section').on('mouseenter', function () {
            clearTimeout(closeTimer);
        }).on('mouseleave', function () {
            // when leaving panel, close the matching nav item
            const id = '#' + this.id;
            const $owner = $(`.item-dropdown[dropdown-collapse="${id}"]`);
            if ($owner.length) hideCurrent($owner);
        });
    }
    */
    if ($('.item-dropdown').length) {

        const $navArea = $('#navbarNav'); // or $('.navbar') if you prefer
        let $active = null;
        let $pending = null;

        const arrow = ($item, open) => {
            if (open) {
                $item.find('> a span, > span').css({ transform: 'rotate(180deg)' });
            } else {
                $item.find('> a span, > span').css({ transform: '' }); // removes the inline style entirely
            }
        };

        const selOf = ($item) => $item.attr('dropdown-collapse');
        function openPanel($item) {
            const sel = selOf($item);
            if (!sel) return;
            $(sel).collapse('show');
            arrow($item, true);
            $active = $item;
            $pending = null;
        }

        function closeAll(callback) {
            const $open = $('.dropdown-section.show, .dropdown-section.collapsing');

            if ($open.length === 0) {
                // Nothing open - execute callback immediately
                if (callback) callback();
                return;
            }

            // With transition:none on .collapsing, hidden.bs.collapse fires near-instantly
            // but we still sequence it properly for safety
            let fired = false;
            $open.first().one('hidden.bs.collapse', function () {
                if (fired) return;
                fired = true;
                if (callback) callback();
            });

            $('.item-dropdown').each(function () {
                const sel = selOf($(this));
                if (sel) $(sel).collapse('hide');
                arrow($(this), false);
            });

            // Safety fallback: if hidden.bs.collapse never fires (Safari edge case),
            // force-open after 50ms anyway
            setTimeout(() => {
                if (fired) return;
                fired = true;
                if (callback) callback();
            }, 50);
        }

        $('.item-dropdown').on('mouseenter', function () {
            const $cur = $(this);
            const sel = selOf($cur);
            if (!sel) return;

            // Already showing this one
            if ($active && $active[0] === this && $(sel).hasClass('show')) return;

            $pending = $cur;

            closeAll(function () {
                // Only open if still the intended target (user may have moved away)
                if ($pending && $pending[0] === $cur[0]) {
                    openPanel($cur);
                }
            });
        });

        $navArea.on('mouseleave', function () {
            $pending = null;
            closeAll(null);
            $active = null;
        });
    }


    $('[mobile-navbar-expand]').on('click', function () {
        var navId = $(this).attr('mobile-navbar-expand');
        $(navId).addClass('navbar-show');

        setTimeout(() => {
            $(navId).addClass('navbar-expanded');
        }, 100);

        $('body').addClass('overflow-hidden')
    });

    $('[mobile-navbar-back]').on('click', function () {
        var navId = $(this).attr('mobile-navbar-back');
        $(navId).removeClass('navbar-expanded');

        setTimeout(() => {
            $(navId).removeClass('navbar-show');
        }, 300);
    });

    $('[mobile-navbar-close]').on('click', function () {
        var navClass = $(this).attr('mobile-navbar-close');
        $(navClass).each(function () {
            $(this).removeClass('navbar-expanded');

            setTimeout(() => {
                $(this).removeClass('navbar-show');
            }, 300);
        });

        $('body').removeClass('overflow-hidden')
    });


    (function () {
        "use strict";

        // Only run when explicitly requested via ?anchordebug=1
        var params = new URLSearchParams(window.location.search);
        if (params.get("anchordebug") !== "1") {
            return;
        }

        function run() {
            var all = document.querySelectorAll("[id]");
            var seen = Object.create(null);
            var order = [];

            for (var i = 0; i < all.length; i++) {
                var id = all[i].id;
                if (!id) { continue; }
                if (seen[id]) {
                    seen[id].push(all[i]);
                } else {
                    seen[id] = [all[i]];
                    order.push(id);
                }
            }

            var duplicates = order.filter(function (id) {
                return seen[id].length > 1;
            });

            renderPanel(duplicates, seen);
        }

        function renderPanel(duplicates, seen) {
            var panel = document.createElement("div");
            panel.setAttribute("role", "region");
            panel.setAttribute("aria-label", "Anchor debug");
            panel.style.cssText =
                "position:fixed;bottom:0;left:0;right:0;z-index:2147483647;" +
                "max-height:40vh;overflow:auto;background:#111;color:#eee;" +
                "font:13px/1.4 monospace;padding:12px 16px;" +
                "box-shadow:0 -2px 12px rgba(0,0,0,.5);";

            var close = document.createElement("button");
            close.textContent = "Close";
            close.style.cssText =
                "float:right;background:#333;color:#fff;border:1px solid #555;" +
                "padding:4px 10px;cursor:pointer;font:12px monospace;";
            close.addEventListener("click", function () {
                panel.parentNode.removeChild(panel);
            });
            panel.appendChild(close);

            var title = document.createElement("div");
            title.style.cssText = "font-weight:bold;margin-bottom:8px;";

            if (duplicates.length === 0) {
                title.textContent = "Anchor debug: no duplicate ids found on this page.";
                panel.appendChild(title);
            } else {
                title.textContent =
                    "Anchor debug: " + duplicates.length +
                    " duplicate id(s) found. A #hash link jumps to the FIRST match only.";
                title.style.color = "#ff8080";
                panel.appendChild(title);

                duplicates.forEach(function (id) {
                    var els = seen[id];
                    var row = document.createElement("div");
                    row.style.cssText = "margin:6px 0;padding:6px;background:#1c1c1c;border-left:3px solid #ff8080;";

                    var head = document.createElement("div");
                    head.style.cssText = "color:#ffd280;margin-bottom:4px;";
                    head.textContent = "#" + id + "  (" + els.length + " elements):";
                    row.appendChild(head);

                    els.forEach(function (el, idx) {
                        var line = document.createElement("div");
                        var comp = el.getAttribute("data-component");
                        line.textContent =
                            "  " + (idx + 1) + ". <" + el.tagName.toLowerCase() + ">" +
                            (comp ? "  data-component=\"" + comp + "\"" : "") +
                            (idx === 0 ? "   <-- hash lands here" : "");
                        line.style.color = idx === 0 ? "#80ff80" : "#bbb";
                        row.appendChild(line);
                    });

                    panel.appendChild(row);
                });
            }

            document.body.appendChild(panel);
        }

        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", run);
        } else {
            run();
        }
    })();

});